export const homePageName = 'home';
export const adminPageName = 'administration';
export const configurationAdministrationPageName = 'configuration-administration';
export const setPasswordPageName = 'set-password';
export const forgotPasswordPageName = 'forgot-password';
export const registerPageName = 'register';
export const confirmEmailPageName = 'confirm-email';
export const changePasswordPageName = 'change-password';
export const editProfilePageName = 'edit-profile';
export const loginPageName = 'login';
export const twoFactorAuthenticationPageName = 'two-factor-authentication';
export const registrationPageName = 'registration';
export const recoveryPageName = 'recovery';
export const fastCheckinPageName = 'fast-checkin';
export const payTillNowPageName = 'pay-till-now';
export const mobileLandingPageName = 'mobile-landing';
export const paymentSuccessfulPageName = 'payment-successful';
export const paymentFailedPageName = 'payment-failed';

export const parkPageName = 'parking';
export const parkingPageName = 'parking';
export const userManagementPageName = 'user-management';
export const userEditPageName = 'user-edit';
export const clientAdministrationPageName = 'client-administration';
export const companyAdministrationPageName = 'company-administration';
export const parkerAdministrationPageName = 'parker-administration';
export const fleetListAdministrationPageName = 'fleet-list-administration';
export const tagsAdministrationPageName = 'tags-administration';
export const onBoardingWizardPageName = 'onboarding-wizard';
export const tagMasterPageName = 'tag-master';
export const thirdPartyUserZoneAssignmentAdministrationPageName = 'third-party-user-zone-assignment-administration';
export const parkingRangerZoneAssignmentAdministrationPageName = 'parking-ranger-zone-assignment-administration';

export const parkingRangerSessionsPageName = 'parking-ranger-sessions';
export const zoneDamagePageName = 'zone-damage';
export const deviceInteractionPageName = 'device-interaction';
export const parkingCardPageName = 'parking-cards';
export const parkingCardAdminPageName = 'parking-card-admin';
export const reportsPageName = 'reports';
export const savedReportsPageName = 'saved-reports';
export const tagsPerParkerPageName = 'tags-per-parker';
export const parkingManagementPageName = 'parking-management';
export const parkerRegistrationsPageName = 'parker-registrations';
export const falseRecordingsPageName = 'false-recordings';
export const parkerTurnoverPageName = 'parker-turnover';
export const parkerExtractPageName = 'parker-extract';
export const iamReportWithTagInformationPageName = 'iam-report-with-tag-information';
export const deviceStatusPageName = 'device-status';
export const parkerPerTariffPageName = 'parker-per-tariff';
export const parkerUtilizationPageName = 'parker-utilization';
export const linkParkerToUserPageName = 'link-parker-to-user';
export const automaticParkingPageName = 'automatic-parking';
export const paymentPageName = 'payment';
export const userExtractPageName = 'user-extract';
export const exportJobsPageName = 'export-jobs';
export const exportJobsCreatePageName = 'create';
export const problemReportAdministrationPageName = 'problem-report-administration';
